import {
  http,
  delayIt,
} from '../utils/http';

export function getList(params) {
  return http.get('/api/oa/approval', {params})
}